import { render } from "./AccountPartial.vue?vue&type=template&id=8f8ee8ba&scoped=true"
import script from "./AccountPartial.vue?vue&type=script&lang=js"
export * from "./AccountPartial.vue?vue&type=script&lang=js"

import "./AccountPartial.vue?vue&type=style&index=0&id=8f8ee8ba&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8ee8ba"]])

export default __exports__